import React from "react";

// Icone bot custom del design (SVG forniti dalla UI/UX designer):
// successo = verde #19D163 con occhi felici, errore = rosso #EF4444
// con occhi a X. Tratto 3.5, viewBox 60.

export const BotSuccessIcon = ({ size = 60, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M30 20V10H20" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M45 20H15C12.2386 20 10 22.2386 10 25V45C10 47.7614 12.2386 50 15 50H45C47.7614 50 50 47.7614 50 45V25C50 22.2386 47.7614 20 45 20Z" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 35H10" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M50 35H55" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 33L21.5 37.3301" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 33.0063L21.5 37.3364" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M41 33L38.5 37.3301" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M36 33.0063L38.5 37.3364" stroke="#19D163" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BotErrorIcon = ({ size = 60, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M30 20V10H20" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M45 20H15C12.2386 20 10 22.2386 10 25V45C10 47.7614 12.2386 50 15 50H45C47.7614 50 50 47.7614 50 45V25C50 22.2386 47.7614 20 45 20Z" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 35H10" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M50 35H55" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24.269 32.2288L18.6122 37.8856" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.7339 32.2357L24.3907 37.8926" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M41.269 32.2288L35.6122 37.8856" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M35.7339 32.2357L41.3907 37.8926" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
